// Entry point for main-app. You will need to move your dynamic loader and admin UI here.

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// 1. Tailwind base + shadcn theme (must be first for @apply to work)
import '@xoxokiosk/ui/src/styles.css';

// 2. App-level overrides
import './main.css';

// 3. Kiosk experience styles (scoped to their own components)
import '@xoxokiosk/story-tree/dist/index.css';
import '@xoxokiosk/dotd/dist/style.css';
import '@xoxokiosk/mirako-avatar/dist/mirako-avatar.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
